import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { numberOnly } from 'projects/common/src/app/services/utils/utilities';

export interface IPagination {
  pageSize: number;
  page: number;
}

@Component({
  selector: 'app-mt-table-pagination',
  templateUrl: './mt-table-pagination.component.html',
  styleUrls: ['./mt-table-pagination.component.scss'],
})
export class MtTablePaginationComponent implements OnInit, OnChanges {
  @Input() pageSize: number;
  @Input() collectionSize: number;

  @Output() changePageSize: EventEmitter<any> = new EventEmitter<IPagination>();
  @Output() changePage: EventEmitter<number> = new EventEmitter<number>();

  public _pageSize: number;
  public page: number;
  public amountPages: number;
  public inputPage: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.collectionSize) {
      this.page = 1;
      this.inputPage = 1;
      this.amountPages = this.getAmountPage();
    }
  }

  ngOnInit() {
    this._pageSize = this.pageSize;
    this.page = 1;
    this.inputPage = 1;
    this.amountPages = this.getAmountPage();
  }

  public onChangePageSize() {
    this.amountPages = this.getAmountPage();
    this.changePageSize.emit({ pageSize: this._pageSize, page: this.page });
  }

  private goBackPage(): void {
    if (this.page !== 1 && this.page > 1) {
      this.page -= 1;
      this.inputPage = this.page;
      this.changePage.emit(this.page);
    }
  }

  private advancePage(): void {
    if (this.page < this.amountPages) {
      this.page += 1;
      this.inputPage = this.page;
      this.changePage.emit(this.page);
    }
  }

  private getAmountPage(): number {
    const amount = Math.ceil(this.collectionSize / this._pageSize);

    // if the current page selected exceeds the total page number
    if (this.page >= amount) {
      this.page = amount;
      this.inputPage = amount;
    }

    return amount;
  }

  public setPage(): void {
    if (this.inputPage !== '') {
      this.inputPage = +this.inputPage; // convert string to number
      if (!isNaN(this.inputPage) && this.inputPage > 0) {
        if (this.inputPage <= this.amountPages) {
          this.page = this.inputPage;
          this.changePage.emit(this.page);
        }
      }
    }
  }

  public keyPress(event): boolean {
    return numberOnly(event);
  }
}
